import { useState, useEffect } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import tesla from "images/tesla.png";
import bmw from "images/bmw.png";

const brands = [
  { name: "Tesla", logo: tesla },
  { name: "BMW", logo: bmw },
];

const CarLogo = () => {
  return (
    <>
      <div className="flex items-center w-full"></div>

      <div className="flex  justify-center gap-12">
        {brands.slice().map((brand, index) => (
          <div
            key={index}
            className="flex  p-6  bg-[#FFFFFF0D] rounded-lg "
          >
            <div className="flex flex-col items-center justify-center w-full">
              <img
                src={brand.logo}
                alt={`${brand.name} logo`}
                className="w-36 h-auto"
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default CarLogo;
